module.exports = {
          srcSet: "/_next/static/images/hirehac-logo-500-56cc7849e2953dffe5cbfa70b57754c6.webp"+" 500w",
          images:[ {path: "/_next/static/images/hirehac-logo-500-56cc7849e2953dffe5cbfa70b57754c6.webp",width: 500,height: 220}],
          src: "/_next/static/images/hirehac-logo-500-56cc7849e2953dffe5cbfa70b57754c6.webp",
          toString:function(){return "/_next/static/images/hirehac-logo-500-56cc7849e2953dffe5cbfa70b57754c6.webp"},
          
          width: 500,
          height: 220
        }